<template>
    <section>
        <el-dialog
  :title="storeLanguage=='en'?'Select Node':'选择节点'"
  visible
  width="50%"
  :before-close="modalClose">  
  <div class="icon-content w-100 dialog-50 " style="overflow-y: auto;">
  <el-tree
              :data="treeList"
              ref="treeRef"
			  empty-text=" "
              :expand-on-click-node="true"
              :check-strictly="true"  
              node-key="id"
              @check="treeCheckClick"
               @node-click="treeNodeClick"
			
              default-expand-all
              show-checkbox
              :props="{children: 'children',label: storeLanguage=='en'?'nameEnglish':'name'}"
            ></el-tree>
          </div>
  <span slot="footer" class="dialog-footer">
    <el-button @click="modalClose">{{$t("dialog.cancel")}}</el-button>
    <el-button type="primary" @click="modalClose">{{$t("dialog.confirm")}}</el-button>
  </span>
</el-dialog> 
</section>
</template>
<script>
 import { listToTree } from "@/js/common.js";
  export default {
	  props: {
	  	url: {
	  		type: String,
	  		default:""
	  	},
		parentId: {
			type: String,
			default:"0"
		},
	  },
    data() {
      return {
        treeList: [],
        selectNode:'' 
      };
    },
    methods: {
      treeNodeClick(e) {
 this.$refs.treeRef.setCheckedKeys([e.id]);
 this.selectNode=e;
      },
      treeCheckClick(e){
		 this.selectNode=e;
		  this.$refs.treeRef.setCheckedKeys([e.id]);
	  }, 
	 
      modalClose(done) {
          this.$emit("callbackTree", this.selectNode)
      },
    },mounted() {
  this.$axios.get(this.url).then(e => {
	  if(e.length==0){
		this.$message.info('暂时没有要选择的数据') ; return
	  }
    this.treeList= listToTree(e,this.parentId);
  });
 },computed: {
    storeLanguage() {
      return this.$store.state.language;
    },
    
  }
  };
</script>